export default __webpack_public_path__ + "f8358c58443908070c01d8c74a7645a1.svg";